import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/system";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

//lodash

//moment
import moment from "moment";
import "moment/locale/zh-hk";

//fetch
import {
  getFullStaffLists,
  getPushNotificationById,
  updatePushNotification,
} from "@/fetch/fetchNotice";

const PushNotificationEditPage = (props) => {
  const { open, setOpen } = props;

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const pathOptions = [
    { name: "更表", action: "ShiftEditScreen" },
    { name: "通知", action: "PushNotification" },
    { name: "盤點", action: "StocktakeList" },
    { name: "通告", action: "Main" },
  ];

  // Navigate and Location and Params
  const navigate = useNavigate();
  const { id } = useParams();

  // States
  const [allSelect, setAllSelect] = React.useState(false);
  const [onChangeData, setOnChangeData] = React.useState({
    recipient: [],
    action: "PushNotification",
    issue_time: moment().format("YYYY-MM-DD"),
  });
  const [options, setOptions] = React.useState([]);
  const [error, setError] = React.useState({});
  const [save, setSave] = React.useState(false);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });

  // Submit
  const onClickSubmit = async () => {
    const reqBody = {
      ...onChangeData,
      recipient: onChangeData.recipient.map((item) => item.id),
    };
    const checkError = {
      title: onChangeData.title ? "" : "不能為空值",
      body: onChangeData.body ? "" : "不能為空值",
      action: onChangeData.action ? "" : "不能為空值",
      recipient: onChangeData.recipient.length > 0 ? "" : "不能為空值",
    };

    if (Object.values(checkError).some((item) => item && true)) {
      setError((prev) => ({
        ...prev,
        ...checkError,
      }));
      return false;
    } else {
      await updatePushNotification(reqBody, id).then((data) => {
        if (data && data.results) {
          setSnackMessage("已修改");
          setSnackOpen(true);
          setSave((prev) => !prev);
          setTimeout(() => {
            setSnackOpen(false);
            navigate(-1);
          }, 1500);
        }
      });
    }
  };

  const fetchAll = async () => {
    const { data, results } = await getFullStaffLists();
    if (results && data)
      setOptions([
        { id: 0, staff_code: "", work_name: "", district_name: "全部" },
        ...data,
      ]);
    await getPushNotificationById(id)
      .then((pushData) => {
        const userIds = pushData.data.recipient?.map((item) =>
          parseInt(item.user_id)
        );
        setOnChangeData((prev) => ({
          ...prev,
          ...pushData.data.payload,
          issue_time: pushData.data.issue_time,
          id: pushData.data.id,
          recipient: data.filter((item) => userIds.includes(item.id)),
        }));
        if (data.length === userIds.length) setAllSelect(true);
      })
      .then(() => setSlideTranOn(true));
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [save]);

  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option) => option.staff_code,
  });

  const GroupHeader = styled("div")(({ children }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    fontSize: 15,
    zIndex: 1,
    backgroundColor: "white",
    cursor: children === "全部" ? "" : "pointer",
  }));

  return (
    <Layout
      header="workLocationManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={17}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`推播通知 / 修改推播 `} history={() => navigate(-1)} />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 7,
                    lg: 7
                  }}>
                  <TextField
                    id="m18_product_code"
                    name="title"
                    label="標題"
                    error={!!error.title}
                    helperText={error.title}
                    value={onChangeData.title}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 5,
                    lg: 5
                  }}>
                  <Autocomplete
                    sx={{ width: "100%" }}
                    multiple
                    id="checkboxes-tags-demo"
                    name="recipient"
                    options={options}
                    value={onChangeData.recipient}
                    disableCloseOnSelect
                    groupBy={(option) => option.district_name}
                    getOptionLabel={(option) => option.staff_code}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionKey={(option) => option.id.toString()}
                    limitTags={10}
                    filterOptions={filterOptions}
                    onInputChange={() => setAllSelect(false)}
                    renderGroup={(params) => {
                      const userId = params.children.map((item) =>
                        parseInt(item.key)
                      );
                      return (
                        <li key={params.key}>
                          <GroupHeader
                            onClick={
                              params.key !== 0
                                ? () =>
                                    setOnChangeData({
                                      ...onChangeData,
                                      recipient: options.filter((option) =>
                                        userId.includes(option.id)
                                      ),
                                    })
                                : () => {}
                            }
                          >
                            {params.group}
                          </GroupHeader>
                          <ul>{params.children}</ul>
                        </li>
                      );
                    }}
                    onChange={(e, newValue) => {
                      if (newValue.map((item) => item.id).includes(0)) {
                        if (e.target.checked) {
                          setAllSelect((prev) => !prev);
                          setOnChangeData({
                            ...onChangeData,
                            recipient: options.filter(
                              (option) => option.id !== 0
                            ),
                          });
                        } else {
                          setAllSelect((prev) => !prev);
                          setOnChangeData({
                            ...onChangeData,
                            recipient: [],
                          });
                        }
                      } else {
                        setAllSelect(false);
                        setOnChangeData({
                          ...onChangeData,
                          recipient: newValue.filter((item) => item.id !== 0),
                        });
                      }
                    }}
                    renderOption={(props, option, { selected }) => {
                      allSelect && (selected = true);
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.staff_code}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={!!error.recipient}
                        helperText={error.recipient}
                        {...params}
                        label="員工"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 7,
                    lg: 7
                  }}>
                  <TextField
                    multiline
                    rows={5}
                    id="work_name"
                    name="body"
                    label="內容"
                    error={!!error.body}
                    helperText={error.body}
                    value={onChangeData.body}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 5,
                    lg: 5
                  }}>
                  <FormControl sx={{ width: "100%" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        disablePast
                        showToolbar
                        minutesStep={15}
                        renderInput={(props) => <TextField {...props} />}
                        label="發送日期"
                        value={onChangeData.issue_time}
                        onChange={(event) => {
                          setOnChangeData({
                            ...onChangeData,
                            issue_time: moment(event.$d).format(
                              "YYYY-MM-DD HH:mm"
                            ),
                          });
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 7,
                    lg: 7
                  }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="select-brands-label">頁面</InputLabel>
                    <Select
                      required
                      id="is_active"
                      name="action"
                      label="頁面"
                      helperText={error.action}
                      value={onChangeData.action}
                      onChange={(event) => {
                        setOnChangeData({
                          ...onChangeData,
                          [event.target.name]: event.target.value,
                        });
                      }}
                    >
                      <MenuItem disabled value={"請選擇"}>
                        請選擇
                      </MenuItem>
                      {pathOptions.map((item, index) => (
                        <MenuItem key={index} value={item.action}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 5,
                    lg: 5
                  }}></Grid>
                {/* <Grid item xs={12} md={7} lg={7}>
                  <TextField
                    id="work_name"
                    name="params"
                    label="參數"
                    value={onChangeData.params}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid> */}
                <Grid
                  size={{
                    xs: 12,
                    md: 5,
                    lg: 5
                  }}></Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <Grid justifyContent={"flex-end"} container spacing={2}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 12,
                        lg: 2
                      }}>
                      <StyledButton
                        variant="contained"
                        size="small"
                        onClick={onClickSubmit}
                      >
                        <Typography variant="subtitle1" noWrap component="div">
                          確認
                        </Typography>
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default PushNotificationEditPage;
